<ng-container *ngIf="opciones.length">
  <button
    pButton
    type="button"
    class="p-button-sm p-button-outlined rc-btn"
    icon="fa-solid fa-file-excel"
    label="Reportes contables"
    aria-haspopup="true"
    [loading]="!!descargando"
    [disabled]="!!descargando"
    (click)="menu.toggle($event)"
  ></button>
  <p-menu #menu [model]="opciones" [popup]="true" appendTo="body" styleClass="rc-menu" [style]="{ width: '18.5rem' }"></p-menu>
</ng-container>

<!-- ── Clientes en mora: se pide por FECHA DE CORTE, no por mes ──────────────────────────────── -->
<p-dialog
  [(visible)]="mostrarMora"
  [modal]="true"
  [closable]="descargando !== 'mora'"
  header="Reporte de clientes en mora"
  styleClass="rc-dialog"
  [style]="{ width: '440px', maxWidth: '96vw' }"
>
  <p class="rc-note">
    Un renglón por cliente con lo que debe por mes de vencimiento, los días de atraso y los moratorios, al día de corte que elijas.
  </p>
  <label for="rc-corte" class="rc-label">Fecha de corte</label>
  <p-calendar
    inputId="rc-corte"
    [(ngModel)]="corte"
    dateFormat="dd/mm/yy"
    [showIcon]="true"
    [maxDate]="hoy"
    appendTo="body"
    styleClass="rc-cal"
  ></p-calendar>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="p-button-text"
      label="Cancelar"
      [disabled]="descargando === 'mora'"
      (click)="mostrarMora = false"
    ></button>
    <button
      pButton
      type="button"
      label="Descargar"
      icon="fa-solid fa-download"
      [loading]="descargando === 'mora'"
      [disabled]="!corte"
      (click)="descargarMora()"
    ></button>
  </ng-template>
</p-dialog>

<!-- ── Ligar complementos con sus pagos ─────────────────────────────────────────────────────── -->
<p-dialog
  [(visible)]="mostrarLiga"
  [modal]="true"
  [closable]="!ligaAplicando"
  header="Ligar complementos con sus pagos"
  styleClass="rc-dialog"
  [style]="{ width: '640px', maxWidth: '96vw' }"
>
  <p class="rc-note">
    Liga cada renglón de los complementos que ya están en la plataforma con el pago que documenta. Es lo que permite saber qué pagos ya
    tienen complemento y, al anular un pago, invalidar solo el suyo. <b>Primero se muestra qué haría</b>; nada se escribe hasta confirmar.
  </p>
  <div class="rc-skeleton" *ngIf="ligaCargando"><p-skeleton height="5rem"></p-skeleton></div>
  <div class="rc-error" *ngIf="ligaError" role="alert">
    <i class="fa-solid fa-circle-exclamation"></i><span>{{ ligaError }}</span>
  </div>
  <ng-container *ngIf="liga && !ligaCargando">
    <div class="rc-stats">
      <div class="rc-stat is-ok">
        <b>{{ liga.linked }}</b
        ><span>se ligarían</span>
      </div>
      <div class="rc-stat">
        <b>{{ liga.alreadyLinked }}</b
        ><span>ya ligados</span>
      </div>
      <div class="rc-stat" [class.is-warn]="liga.unlinked.length">
        <b>{{ liga.unlinked.length }}</b
        ><span>sin poder ligar</span>
      </div>
    </div>
    <div *ngIf="liga.unlinked.length" class="rc-list">
      <p class="rc-note">
        Estos no se ligan porque no hay un pago que coincida sin ambigüedad. Aparecerán como «complemento sin pago» en el control:
      </p>
      <table class="rc-table">
        <thead>
          <tr>
            <th>Complemento</th>
            <th>Factura</th>
            <th>Por qué</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of liga.unlinked">
            <td>{{ u.complement }}</td>
            <td>{{ u.invoice || '—' }}</td>
            <td>{{ u.reason }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="rc-note" *ngIf="!liga.linked">No hay nada nuevo que ligar.</p>
  </ng-container>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Cerrar" [disabled]="ligaAplicando" (click)="mostrarLiga = false"></button>
    <button
      pButton
      type="button"
      icon="fa-solid fa-link"
      [label]="'Ligar ' + (liga?.linked || 0)"
      [loading]="ligaAplicando"
      [disabled]="ligaCargando || !liga?.linked"
      (click)="aplicarLiga()"
    ></button>
  </ng-template>
</p-dialog>
